module.exports = __webpack_public_path__ + "media/images/about2-02930668b2fea3c2440c1ada554a529f.png";